// extracted by mini-css-extract-plugin
module.exports = {"melodyCardCategory":"pg-z","categoryName":"qg-z","categoryImage":"rg-z","categoryContent":"sg-z","bottomAligned":"tg-z"};